import { render, staticRenderFns } from "./MainSectionFour.vue?vue&type=template&id=6ccb5a26&scoped=true&lang=pug&"
import script from "./MainSectionFour.vue?vue&type=script&lang=js&"
export * from "./MainSectionFour.vue?vue&type=script&lang=js&"
import style0 from "./MainSectionFour.vue?vue&type=style&index=0&id=6ccb5a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb5a26",
  null
  
)

export default component.exports